export default __webpack_public_path__ + "static/media/MiniAmericanTourister.9ec90066.jpg";